import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { Box, Grid, GridItem, Heading } from '@chakra-ui/react';
import { AdditionalFacilitiesFormFields } from 'src/@types';
import { additionalFacilitiesFormFields } from '../config';
import { FormElementDynamicInputTyped } from '../../../../shared/form-elements';

export const AdditionalFacilitiesLifeInsuranceSection = ({
  heading,
  register,
  values,
  errors
}: {
  heading: string;
  register: UseFormRegister<AdditionalFacilitiesFormFields>;
  values: AdditionalFacilitiesFormFields;
  errors: FieldErrors<AdditionalFacilitiesFormFields>;
}) => {
  return (
    <>
      <Heading size={`md`}>{heading}</Heading>
      <Grid
        templateColumns={{
          base: 'repeat(1, 1fr)'
        }}
        gap={4}>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
            formFields={additionalFacilitiesFormFields}
            id={'doesTheCompanyHasCollectiveLifeInsurancePolicy'}
            register={register}
            errors={errors}
            values={values}
            options={{ required: true }}
          />
        </GridItem>

        <GridItem colSpan={{ base: 1, md: 2 }}>
          <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
            formFields={additionalFacilitiesFormFields}
            id={'isTheEmployeeInsuredByAnwInsurance'}
            register={register}
            errors={errors}
            values={values}
            options={{ required: true }}
          />
        </GridItem>

        {values.isTheEmployeeInsuredByAnwInsurance === 'true' && (
          <Box>
            <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
              formFields={additionalFacilitiesFormFields}
              id={'annualPaymentOfTheAnwInsurance'}
              register={register}
              errors={errors}
              values={values}
              options={{ optionalStyle: true, required: true }}
            />

            <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
              formFields={additionalFacilitiesFormFields}
              id={'anwBenefitStartingStatement'}
              register={register}
              errors={errors}
              values={values}
              options={{ optionalStyle: true, required: true }}
            />
          </Box>
        )}
      </Grid>
    </>
  );
};
